<template lang="pug">
div.pt-0.pb-8
  v-data-table(:headers="headers" :items="items" item-key="id" :items-per-page="pageSize" hide-default-footer disable-sort :loading="isFetching")
    template(v-slot:item.user="{ item, headers, index }")
      div.font-semibold(v-if="item.primary_owner") {{ $t('main_admin') }}
      div.font-semibold(v-else) {{ (item.user.first_name || item.user.last_name) ? `${item.user.first_name ? item.user.first_name + ' ' : ''}${item.user.last_name}` : '-' }}
    template(v-slot:item.date="{ item, headers, index }")
      div {{ item.created | humanizeDate }}
    template(v-slot:item.time="{ item, headers, index }")
      div {{ item.created | displayTime2 }}
  div.d-flex.align-center.py-6
    v-spacer
    div
      yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" text="Show logs" attach menu-top @input="pageChanged")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'UserLog',
  components: {},
  data () {
    return {
      isFetching: false,
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      items: [],
      headers: [
        {
          text: 'Name',
          value: 'user',
          enable: true,
          class: 'text-xs font-bold neutral500--text text-uppercase'
        },
        {
          text: 'Date',
          value: 'date',
          enable: true,
          class: 'text-xs font-bold neutral500--text text-uppercase'
        },
        {
          text: 'Time',
          value: 'time',
          enable: true,
          class: 'text-xs font-bold neutral500--text text-uppercase'
        },
        {
          text: 'Activity',
          value: 'activity',
          enable: true,
          class: 'text-xs font-bold neutral500--text text-uppercase'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
  },
  watch: {
    pageSize () {
      this.fetchLogs(1)
    }
  },
  mounted () {
    this.fetchLogs(1)
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchLogs (page) {
      this.isFetching = true
      const params = {
        page_size: this.pageSize,
        page,
        company: this.company.id,
      }
      this.$axios.get(`/users/logs`, { params } )
        .then(resp => {
          this.items = resp.data.results
          this.totalCount = resp.data.count
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    pageChanged (num) {
      this.fetchLogs(num)
    },
  }
}
</script>
